import { render, staticRenderFns } from "./LocalView.vue?vue&type=template&id=2f8aafd0&scoped=true&"
import script from "./LocalView.vue?vue&type=script&lang=js&"
export * from "./LocalView.vue?vue&type=script&lang=js&"
import style0 from "./LocalView.vue?vue&type=style&index=0&id=2f8aafd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8aafd0",
  null
  
)

export default component.exports